export enum SignInQASelectors {
    REGISTER_LOGIN_FORM = 'register-login-form',
    EMAIL = 'email',
    PASSWORD = 'password',
    SIGN_IN = 'sign-in',
}